import React, { useState, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { Alert } from 'tdesign-react';

function LicenseTip({ licenseInfo }) {
  const [isPaused, setIsPaused] = useState(false);
  const [expiredSoon, setExpiredSoon] = useState(false);
  const [promptInfo, setPromptInfo] = useState();

  const togglePause = () => {
    setIsPaused((prev) => !prev);
  };

  useEffect(() => {
    if ('expiredSoon' in licenseInfo) {
      setExpiredSoon(licenseInfo.expiredSoon);
      setPromptInfo(licenseInfo.promptInfo);
    }
  }, [licenseInfo]);

  // 处理特殊字段
  const handleLicenseMsg = (data) => {
    if (!data) {
      return;
    }
    // 匹配以 [] 结尾的部分
    const regex = /\[(.*?)\]/g;
    // 使用 replace 方法替换匹配到的部分
    const resultString = data.replace(regex, function (match, p) {
      return ` <span style="padding: 3px 6px; background-color: var(--td-brand-color-light); color: var(--td-brand-color);border-radius: var(--td-radius-default);
      border: 1px solid transparent;">${p}</span> `;
    });
    return <span dangerouslySetInnerHTML={{ __html: resultString }}></span>;
  };

  return (
    <Root
      style={{ display: expiredSoon ? 'block' : 'none' }}
      onMouseEnter={togglePause}
      onMouseLeave={togglePause}
    >
      <MarqueeContainer isPaused={isPaused}>
        <MarqueeText>
          <Alert theme='info' message={handleLicenseMsg(promptInfo)} />
        </MarqueeText>
      </MarqueeContainer>
    </Root>
  );
}

export default connect((state) => ({
  licenseInfo: state.auth.licenseInfo,
}))(LicenseTip);

const Root = styled.div`
  height: 50px;
  line-height: 50px;
  // background: var(--td-warning-color-focus);
  background: #e5eafa;
  overflow: hidden;
  position: relative;
`;

const marqueeAnimation = keyframes`
  from {
    transform: translateX(100vw);
  }
  to {
    transform: translateX(-100%);
  }
`;

const MarqueeContainer = styled.div`
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  ${(props) =>
    css`
      animation: ${marqueeAnimation} 20s linear infinite;
      animation-play-state: ${props.isPaused ? 'paused' : 'running'};
    `}
`;

const MarqueeText = styled.div`
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  padding: 0 20px;
  .t-alert--info {
    height: 50px;
    background: #e5eafa;
  }
`;
